import { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { PlusIcon } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import VendorQuickView from "../../popup";
import VendorModal from "../../../../component/popup/add-update-vendor";
import { Link } from "react-router";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import StatusChip from "../../../../component/ui/chip/status";
import { TitleHeading } from "../../../../component/ui/layout";
import { AlphabetIcon, CategoryIcon, StatusIcon } from "../../../../component/icons/filter-icons";

const FleetVendorList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [addModal, setAddModal] = useState(false);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
  }, []);

  const viewDetail = (ele, type) => {
    setIsShowModal(true);
    setCurrentData({ ...ele, type });
  };

  const getData = async ({ filter = filterReturn, page = "" }) => {
    if (!page) {
      setIsLoading(true);
    }
    let extraUrl = `?page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `all-vendor-fleet${extraUrl}`,
      });
      if (page) {
        setList((prev) => [...prev, ...res.vendorsList]);
      } else {
        setList(res.vendorsList);
      }
      setTableHeaders(res?.headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };


  

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
    setAddModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const filterModalData = [
    {
      name: "search_by_name",
      label: "Vendor Name",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: AlphabetIcon
    },
    {
      name: "search_by_status",
      label: "Status",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Active", val: "1" },
        { label: "In Active", val: "0" },
      ],
      dropdownKey: "label",
      dropdownVal: "val",
      Icon: StatusIcon
    },
    {
      name: "search_by_vendor_type",
      label: "Vendor Type",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Car", val: "Car" },
        { label: "Van", val: "Van" },
      ],
      dropdownKey: "label",
      dropdownVal: "val",
      Icon: CategoryIcon
    },
  ];

  const tableRef = useRef(null);

  const editDetail = (ele, type) => {
    setCurrentData({ ...ele, type });
    setAddModal(true);
  };

  return (
    <>
      <div className={Style.leaveMainPage}>
        <div className={Style.report_table__header}>
          <TitleHeading title={`Vendor List`} />

          <div className={Style.bpfl_action}>
            <div
              className={Style.bpfl_action}
              onClick={() => {
                setAddModal(true);
              }}
            >
              <Tooltip
                content={"Add Vendor"}
                position={"left center"}
                className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
              >
                <div className={Style.icon}>
                   <PlusIcon size={'1em'} />
                </div>
              </Tooltip>
            </div>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${
                  filterReturn?.length ? Style.active : null
                }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
            <div className={`${Style.bpfl_action}`}>
              <Tooltip
                className={`${Style.bpfl_actionItems}`}
                content={"Customize Table"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn}`}
                  onClick={() => {
                    setShowModalCustomizeTabs(true);
                  }}
                >
                  <div className={Style.icon}>
                    <LayoutTopIcon />
                  </div>
                </div>
              </Tooltip>
            </div>
            
          </div>
        </div>

        <div className={Style.LeaveBody}>
          {isLoading ? (
            <InnerLoader />
          ) : !lists?.length ? (
            <DataNotFound title={"lists"} />
          ) : (
            <>
              <TableCard ref={tableRef}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell header sticky>
                        <div className="flex gap-4 items-center">
                          <span>Name</span>
                        </div>
                      </TableCell>
                      {tableHeaders?.map((eachHead, index) =>
                        eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                          <TableCell header key={index}>
                            <TableHeaderWrap>
                              <span>{eachHead?.value}</span>
                            </TableHeaderWrap>
                          </TableCell>
                        ) : null
                      )}

                      {/* <TableCell header><TableHeaderWrap><span>Time In</span></TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap><span>Time Out</span></TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap><span>Working Hour</span></TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap><span>Status</span></TableHeaderWrap></TableCell> */}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {lists?.map((eachList, index) => {
                      return (
                        <TableRow key={`${index}`}>
                          <TableCell sticky>
                            <div className={`${Style.tableActionArea} !gap-4`}>
                              {/* <div className="flex items-center gap-1">
                                  <div className={Style.btn} onClick={() => { viewDetail(eachList, eachList?.vehicle_type) }}>
                                    <div className={Style.icon} style={{ color: '#0284c7' }}><Eye className="h-4.5 w-4.5" /></div>
                                  </div>
                                  <div className={Style.btn} onClick={() => { editDetail(eachList, eachList?.vehicle_type) }}>
                                    <div className={Style.icon} style={{ color: '#d97706' }}><Pencil className="h-4.5 w-4.5" /></div>
                                  </div>
                                </div> */}
                              <div className="flex items-center gap-3">
                                {eachList?.vendor_logo ? (
                                  <img
                                    className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                    src={eachList?.vendor_logo}
                                    alt={eachList?.vendor_company_name}
                                  />
                                ) : (
                                  <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                    {eachList?.vendor_company_name?.split(
                                      " "
                                    )[0]
                                      ? eachList?.vendor_company_name?.split(
                                          " "
                                        )[0][0]
                                      : ""}
                                    {eachList?.vendor_company_name?.split(
                                      " "
                                    )[1]
                                      ? eachList?.vendor_company_name?.split(
                                          " "
                                        )[1][0]
                                      : ""}
                                  </div>
                                )}
                                <div>
                                  <div className="font-medium leading-5">
                                    {eachList?.vendor_name}
                                  </div>
                                  {/* <div className="text-xs text-muted-foreground">
                                    {eachList?.vendor_company_name}
                                  </div> */}
                                </div>
                              </div>

                              <div className={Style.tableActionAreaBtnGrpup}>
                                <div
                                  className={
                                    "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                  }
                                  onClick={() => {
                                    editDetail(
                                      eachList,
                                      eachList?.vehicle_type
                                    );
                                  }}
                                >
                                  <div
                                    className={Style.icon}
                                    style={{ color: "#FF9500" }}
                                  >
                                    <NewEditIcon className="h-4.5 w-4.5" />
                                  </div>
                                </div>

                                <div
                                  className={
                                    "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                  }
                                  onClick={() => {
                                    viewDetail(
                                      eachList,
                                      eachList?.vehicle_type
                                    );
                                  }}
                                >
                                  <div
                                    className={Style.icon}
                                    style={{ color: "#007AFF" }}
                                  >
                                    <NewEyeIcon className="h-4.5 w-4.5" />
                                  </div>
                                </div>

                                {/* <Link
                                  to={`/organization/employee-directory/${ele.id}`}
                                  className={
                                    "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                  }
                                >
                                  <div
                                    className={Style.icon}
                                    style={{ color: "#34C759" }}
                                  >
                                    <NewCardIcon className="h-4.5 w-4.5" />
                                  </div>
                                </Link> */}
                              </div>
                            </div>
                          </TableCell>
                          {tableHeaders?.map((eachHead, i) =>
                            eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                              <>
                                {eachHead?.key == "contract_document" ? (
                                  <TableCell key={`${i}-${index}`}>
                                    {eachList[eachHead?.key] ? (
                                      <Link
                                        to={eachList[eachHead?.key]}
                                        target="_blank"
                                        className="underline decoration-solid hover:text-sky-800"
                                      >
                                        View Contract
                                      </Link>
                                    ) : (
                                      "-"
                                    )}
                                  </TableCell>
                                ) : eachHead.key === "status" ? (
                                  <TableCell
                                    key={`${i}-${index}`}
                                    className={`text-center`}
                                  >
                                    {eachList[eachHead?.key] === "Active" ? (
                                      <StatusChip color="green">
                                        {eachList[eachHead?.key] || "--"}
                                      </StatusChip>
                                    ) : eachList[eachHead?.key] ===
                                      "In-Active" ? (
                                      <StatusChip color="red">
                                        {eachList[eachHead?.key] || "--"}
                                      </StatusChip>
                                    ) : (
                                      <StatusChip color="blue">
                                        {eachList[eachHead?.key] || "--"}
                                      </StatusChip>
                                    )}
                                  </TableCell>
                                ) : (
                                  <TableCell key={`${i}-${index}`}>
                                    {eachList[eachHead?.key] ?? "-"}
                                  </TableCell>
                                )}
                              </>
                            ) : null
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableCard>
            </>
          )}
        </div>

        {!isLoading ? (
          <div className={Style.table_footer} style={{ alignItems: "center" }}>
            <div className={Style.table_footer_left}>
              {`showing 1 to ${lists?.length} of ${
                tablePagination?.total || lists?.length
              }`}
            </div>

            {tablePagination ? (
              <div className={Style.empDirectory_footer}>
                {tablePagination?.next_page_url ? (
                  <button
                    className={Style.loadMoreBtn}
                    onClick={() => {
                      if (btnLoader) return;
                      // setPageCount(pageCount + 1);
                      setBtnLoader(true);
                      // filterData({ page: pageCount + 1, btnCall: true });
                      getData({ page: tablePagination?.next_page_url });
                    }}
                  >
                    {btnLoader ? (
                      <InnerLoader
                        className={Style.loader}
                        textStatus={false}
                      />
                    ) : (
                      "Load More"
                    )}
                  </button>
                ) : null}
              </div>
            ) : null}

            <div
              className={`${Style.table_footer_left} ${Style.rightText}`}
            ></div>
          </div>
        ) : (
          <div className={Style.table_footer} style={{ alignItems: "center" }}>
            <div className={Style.table_footer_left}>
              <Skeleton width={"50%"} height={15} />
            </div>

            <div className={Style.empDirectory_footer}>
              <Skeleton width={"180px"} height={40} />
            </div>

            <div
              className={`${Style.table_footer_left} ${Style.rightText}`}
            ></div>
          </div>
        )}
      </div>

      {isShowModal && (
        <VendorQuickView
          data={currentData}
          type={currentData?.type}
          onClose={() => {
            setIsShowModal(false);
            setCurrentData({});
          }}
        />
      )}

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="all-vendor-fleet"
        />
      )}

      {addModal && (
        <VendorModal
          onClose={() => {
            setAddModal(false);
            setCurrentData({});
          }}
          onError={onError}
          onSubmit={onSuccess}
          vendorData={currentData}
          type={currentData?.type || ""}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="all-vendor-fleet"
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FleetVendorList;
